import { createSlice } from 'utils/@reduxjs/toolkit';
import { UserState } from './types';
import { reducers } from './reducers';

export const initialState: UserState = {
  isLoading: false,
  error: null,
  data: {
    customerNumber: '',
    isGuestUser: true,
    loggedIn: false,
    loginUrl: '',
    organizationName: '',
    userId: '',
    userSalesChannel: '',
    userSegment: '',
    userType: '',
  },
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers,
});

export const { actions: userActions } = slice;
export const { reducer: userReducer } = slice;
